export const secondsToHHMMSS = (expireTime: string) => {
  const now = +new Date();
  const expiresAt = +new Date(expireTime);
  const remainingTimeInSeconds = Math.abs(expiresAt - now) / 1000;
  const HH = `${Math.floor(remainingTimeInSeconds / 3600)}`.padStart(2, '0');
  const MM = `${Math.floor(remainingTimeInSeconds / 60) % 60}`.padStart(2, '0');
  const SS = `${Math.floor(remainingTimeInSeconds % 60)}`.padStart(2, '0');
  return [HH, MM, SS].join(':');
};

export const formatDateToMonthYear = (datetime: string | undefined) => {
  if (datetime) {
    const formattedDate = new Date(datetime);
    return `${formattedDate.toLocaleString('default', {
      month: 'long',
    })} ${formattedDate.getFullYear()}`;
  } else {
    return '';
  }
};

export const formatDateToYYYYMMDD = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDateToDDMMYYYY = (date: Date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatDateToMonthDayYear = (date: Date) => {
  return date.toLocaleDateString('en-us', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getEndOfToday = () => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return today;
};
